import noUiSlider from 'nouislider';
import {onDomReady} from "../../components/dynamic/observer";
import LiveEvent from "../../components/live/live";
import Modal from "../../components/modal/modal";

onDomReady(() => {
    const sliders = document.querySelectorAll('[data-js-range]');

    if (!sliders.length) return;

    sliders.forEach(sliderEl => {
        const inputName = sliderEl.dataset.inputName;
        const input = document.querySelector(`input[name="${inputName}"]`);
        const min = parseFloat(sliderEl.dataset.min);
        const max = parseFloat(sliderEl.dataset.max);
        const step = parseFloat(sliderEl.dataset.step);

        noUiSlider.create(sliderEl, {
            start: [parseFloat(input.value) || min],
            connect: [true, false],
            range: { min, max },
            step,
        });

        const valueEl = sliderEl.parentElement.querySelector('[data-range-single-show]');
        sliderEl.noUiSlider.on('update', values => {
            const val = Math.round(values[0]);
            input.value = val;
            if (valueEl) valueEl.textContent = val;
            calculateTotal();
        });
    });

    function calculateTotal() {
        const userCount = parseInt(document.querySelector('input[name$="[userCount]"]').value) || 0;
        const ssd = parseInt(document.querySelector('input[name$="[ssdCapacity]"]').value) || 0;
        const hdd = parseInt(document.querySelector('input[name$="[hddCapacity]"]').value) || 0;
        const cores = parseInt(document.querySelector('input[name$="[coreCount]"]').value) || 0;
        const ram = parseInt(document.querySelector('input[name$="[ramCapacity]"]').value) || 0;

        const total = userCount*10 + ssd*2 + hdd*1 + cores*50 + ram*5;

        document.querySelector('.js-total-price').textContent = total.toLocaleString('ru-RU');

        const totalInput = document.querySelector('input[name$="[totalParams]"]');
        if (totalInput) {
            totalInput.value = JSON.stringify({ userCount, ssd, hdd, cores, ram, total });
        }
    }

    calculateTotal();

    document.querySelectorAll('.constructor__hidden-input').forEach(input => {
        input.addEventListener('input', () => {
            const sliderEl = document.querySelector(`[data-js-range][data-input-name="${input.name}"]`);
            if (sliderEl && sliderEl.noUiSlider) {
                sliderEl.noUiSlider.set(input.value);
            }
            calculateTotal();
        });
    });

    new LiveEvent('click', '[data-modal-calc-rent]', function (e) {
        e.preventDefault();

        const modalTrigger = this;

        const userCountInput = document.querySelector('input[name$="[userCount]"]');
        const ssdCapacityInput = document.querySelector('input[name$="[ssdCapacity]"]');
        const hddCapacityInput = document.querySelector('input[name$="[hddCapacity]"]');
        const coreCountInput = document.querySelector('input[name$="[coreCount]"]');
        const ramCapacityInput = document.querySelector('input[name$="[ramCapacity]"]');

        const modal = new Modal(modalTrigger, {
            closerText: '',
            onAfterOpen() {
                const modalForm = this.content.querySelector('form');

                if (!modalForm) return;

                const modalMachinesInput = modalForm.querySelector('input[name$="[userCount]"]');
                const modalServersInput = modalForm.querySelector('input[name$="[ssdCapacity]"]');
                const modalOfficeMachinesInput = modalForm.querySelector('input[name$="[hddCapacity]"]');
                const modalCpuInput = modalForm.querySelector('input[name$="[coreCount]"]');
                const modalRamCapacity = modalForm.querySelector('input[name$="[ramCapacity]"]');

                const excludedFields = [
                    'userCount',
                    'ssdCapacity',
                    'hddCapacity',
                    'hdd_capacity',
                    'coreCount',
                    'ramCapacity',
                ];

                excludedFields.forEach((fieldName) => {
                    const label = modalForm.querySelector(`label[for*="${fieldName}"]`);
                    if (label) {
                        label.style.display = 'none';
                    }
                });

                if (modalMachinesInput && userCountInput) {
                    modalMachinesInput.value = userCountInput.value;
                }

                if (modalServersInput && ssdCapacityInput) {
                    modalServersInput.value = ssdCapacityInput.value;
                }

                if (modalOfficeMachinesInput && hddCapacityInput) {
                    modalOfficeMachinesInput.value = hddCapacityInput.value;
                }

                if (modalCpuInput && coreCountInput) {
                    modalCpuInput.value = coreCountInput.value;
                }

                if (modalRamCapacity && ramCapacityInput) {
                    modalRamCapacity.value = ramCapacityInput.value;
                }
            },
        });

        return false;
    });
})